import React, { useState, useContext, useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import MasterDataService from '../../../services/master-data';
import LenderUgroService from '../../../services/lender'
import Button from '../../../components/Common/Button';
import Modal from '../../../components/Modal'
import { Context } from "../../../config/store";
import message from '../../../constant/message';
import { toast } from "react-toastify";

const CollectionDetails = () => {
    const { state } = useContext(Context);
    const [searchParams, setSearchParams] = useSearchParams();
    const [emiDeposited, setEmiDeposited] = useState(null)
    const [loanPaymentMode, setLoanPaymentMode] = useState(null)
    const [emiCollected, setEmiCollected] = useState(null)
    // part1 hooks
    const [escrowAccNumber, setEscrowAccNumber] = useState('')
    const [repaymentAmount, setRepaymentAmount] = useState('')
    const [transactionRemarks, setTransactionRemarks] = useState('')
    // part2 hooks
    const [amount, setAmount] = useState('')
    const [beneficiaryAccNumber, setBeneficiaryAccNumber] = useState('')
    const [beneficiaryAccType, setBeneficiaryAccType] = useState('')
    const [beneficiaryIFSC, setBeneficiaryIFSC] = useState('')
    const [beneficiaryName, setBeneficiaryName] = useState('')
    const [remarks, setRemarks] = useState('')
    // common hooks
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [showDataModal, setShowDataModal] = useState(false)
    const [noMore, setNoMore] = useState(false)
    const [part1, setPart1] = useState(false)
    const [part2, setPart2] = useState(false)
    const [apiStatus1, setApiStatus1] = useState(null)
    const [apiStatus2, setApiStatus2] = useState(null)
    const [finalStatus, setFinalStatus] = useState(null)
    const [collectionsData, setCollectionsData] = useState({})
    const [loading, setLoading] = useState(false)
    const [loader, setLoader] = useState(false)
    const [waitLoader, setWaitLoader] = useState(false)
    const [errors, setErrors] = useState({});
    const [lafId, setLafId] = useState('');
    const [custName, setCustName] = useState('');

    const lead_id = useParams().id;
    const cl_lender_id = 16;

    useEffect(()=>{
        getCollectionsData();
    },[lead_id, cl_lender_id])

    const handleConfirmationModal = () => {
        setShowConfirmationModal(false)
        if(part1){
            handelKVBFormData()
        }else if(part2){
            handelUgroFormData()
        }
    }

    const handelKVBFormData = async () => {
        try {
            let payloadData = {
                'emi_deposited': emiDeposited,
                'emi_collected' : emiCollected,
                'LoanPaymentMode' : loanPaymentMode,
                'cl_lead_id': lead_id,
                'lender_id': cl_lender_id,
                'EscrowAccount': escrowAccNumber,
                'Amount': repaymentAmount,
                'Narration': transactionRemarks
            }
            setLoading(true);
            const apiResponse = await LenderUgroService.saveCollectionsData({
                type: state.userType,
                payloadData
            });
            if (apiResponse?.data?.status?.code === 1) {
                if(apiResponse?.status == 200)
                    toast.success(apiResponse?.data?.messages?.success?.others[0] || message.SAVED_SUCCESS)
                else
                    toast.error(apiResponse?.data?.messages?.success?.others[0] || message.SAVED_SUCCESS)
                setShowDataModal(false);
                getCollectionsData();
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0]);
            setErrors(error?.fields);
        }
    }

    const handelUgroFormData = async () => {
        try {
            let payloadData = {
                'cl_lead_id': lead_id,
                'lender_id': cl_lender_id,
                'Amount': amount,
                'BenAcctNo': beneficiaryAccNumber,
                'BenAcctType': beneficiaryAccType,
                'BenIFSC' : beneficiaryIFSC,
                'BenName' : beneficiaryName,
                'Remarks' : remarks,

            }
            setLoading(true);
            const apiResponse = await LenderUgroService.saveCollectionsData({
                type: state.userType,
                payloadData
            });
            if (apiResponse?.data?.status?.code === 1) {
                if(apiResponse?.status == 200)
                    toast.success(apiResponse?.data?.messages?.success?.others[0] || message.SAVED_SUCCESS)
                else
                    toast.error(apiResponse?.data?.messages?.success?.others[0] || message.SAVED_SUCCESS)
                setShowDataModal(false);
                getCollectionsData();
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            let error = err?.response?.data?.messages?.error;
            toast.error(error?.form?.[0] || error?.others?.[0]);
            setErrors(error?.fields);
        }
    }

    const getCollectionsData = async () => {
        try {
            setLoader(true);
            let leadResData = await MasterDataService.getLAF(
                'admin',
                'co-lender',
                lead_id
            )
            setLafId(leadResData?.data?.data?.lead?.laf_id)
            setCustName(leadResData?.data?.data?.lead?.company_name || leadResData?.data?.data?.lead?.cust_name)
            const response = await LenderUgroService.getCollectionsData({
                type: state.userType,
                leadId: lead_id,
                cl_lender_id: cl_lender_id,
            });
            let resData = response?.data?.data || {};
            if(resData?.final_status == 1 && resData?.payment_mode == 4){
                setNoMore(true);
            }else{
                setNoMore(false);
                setCollectionsData(resData)
                setApiStatus1(resData?.api_status1)
                setApiStatus2(resData?.api_status2)
                setFinalStatus(resData?.final_status)
                setEmiDeposited(resData?.emi_deposited)
                setEmiCollected(resData?.emi_collected)
                setLoanPaymentMode(resData?.payment_mode)
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    }

    const getCollectionsPrefilledData = async (payment_mode, type) => {
        try {
            setLoading(true);
            let response = await LenderUgroService.getCollectionsPrefilledData({
                type: state.userType,
                leadId: lead_id,
                cl_lender_id: cl_lender_id,
                payment_mode: payment_mode, // payment mode EMI or Foreclosure
                pay_to: type, // part1 or part2
            })
            
            let resData = response?.data?.data.res || {};
            setPrefilledData(resData);
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    }

    const handleBankShareData = async (e) => {
        let payment_mode = e?.target?.value || '';
        setLoanPaymentMode(payment_mode)
        setErrors({})
        setWaitLoader(true)
        if(payment_mode == 1 && apiStatus1 !== 1){
            await getCollectionsPrefilledData(payment_mode, 1);
            setShowDataModal(true)
            setPart2(false)
            setPart1(true)
        }else if(payment_mode == 4 && apiStatus1 !== 1){
            await getCollectionsPrefilledData(payment_mode, 1);
            setShowDataModal(true)
            setPart2(false)
            setPart1(true)
        }
        setWaitLoader(false)
    }

    const handleRetry = async () => {
        if(apiStatus1 == 1 && ![0,1].includes(apiStatus2)){
            await getCollectionsPrefilledData(loanPaymentMode, 2);
        }
        if(apiStatus1 == 0){
            setErrors({})
            setPart2(false)
            setPart1(true)
            setExistingData()
            setShowDataModal(true)
        }else if(apiStatus1 == 1 && (apiStatus2 != 1 || finalStatus == 0)){
            setErrors({})
            setPart1(false)
            setPart2(true)
            setExistingData()
            setShowDataModal(true)
        } 
    }

    const setPrefilledData = (prefilledData) => {
        // pat1 data
        setEscrowAccNumber(prefilledData?.EscrowAccount);
        setRepaymentAmount(prefilledData?.Amount);
        setTransactionRemarks('');
        // part2 data
        setAmount(prefilledData?.Amount);
        setBeneficiaryAccNumber(prefilledData?.BenAcctNo);
        setBeneficiaryAccType('');
        setBeneficiaryIFSC(prefilledData?.BenIFSC);
        setBeneficiaryName(prefilledData?.BenName);
        setRemarks('')
    }

    const setExistingData = () => {
        if(apiStatus1 == 0){
            setEscrowAccNumber(collectionsData?.collection1?.EscrowAccount);
            setRepaymentAmount(collectionsData?.collection1?.Amount);
            setTransactionRemarks(collectionsData?.collection1?.Narration);
        }else if(apiStatus1 == 1 && (apiStatus2 == 0 || finalStatus == 0)){
            setAmount(collectionsData?.collection2?.Amount);
            setBeneficiaryAccNumber(collectionsData?.collection2?.BenAcctNo);
            setBeneficiaryAccType(collectionsData?.collection2?.BenAcctType);
            setBeneficiaryIFSC(collectionsData?.collection2?.BenIFSC);
            setBeneficiaryName(collectionsData?.collection2?.BenName);
            setRemarks(collectionsData?.collection2?.Remarks);
        }
    }

    return (
        <div className='d-flex justify-content-center mt-3'>
            <div className='tab panel overflow-unset py-3 px-3 w-100' style={{"min-height": '540px'}}>
                <div style={{ fontWeight: 600, fontSize: "12px", padding: "4px 16px 4px 0", color: "#4A4E88", borderRadius: "0px" }}>
                    <span style={{ color: "black" }}>Customer Name : </span>{`${custName}`}
                </div>
                <div style={{ fontWeight: 600, fontSize: "12px", padding: "4px 16px 4px 0", color: "#4A4E88", borderRadius: "0px" }}>
                    <span style={{ color: "black" }}>LAF : </span>{`${lafId}`}
                </div>
                {!noMore && apiStatus2 == 1 && ![0,1].includes(finalStatus) &&
                <div style={{'width': '100%'}}>
                    <button type="button" title='Refresh' disabled={loader || loading} style={{'float': 'right', 'position': 'relative', 'marginTop': '-25px', 'width': '44px'}} class="btn btn-custom btn-custom-height" onClick={getCollectionsData}>
                        { (loader || loading) ?
                        <div className="loader"></div>:
                        <i class="fa fa-refresh" style={{'fontSize': '18px'}} aria-hidden="true"></i>
                        }
                        </button>
                </div>
                }
                <hr />
                <div className='d-flex'>
                    <div style={{'width': '100%'}}>
                        {(apiStatus1 == 0) &&
                            <button type="button" style={{'float': 'right', 'position': 'relative'}} class="btn btn-custom btn-custom-height" onClick={handleRetry}>Retry for KVB Share</button>
                        }
                    </div>
                </div>
                {noMore ?
                    <div className='d-flex mb-3' style={{'margin-top': '10px'}}>
                        <span style={{ 'fontSize': '13px', 'width': '70%', 'margin-left': '40%', 'font-weight': '600' }}>
                            This loan has been foreclosed. Thank you
                        </span>
                    </div>
                :
                    <div className='d-flex mb-3' style={{'margin-top': '10px'}}>
                        <span style={{ fontSize: '13px', width: '70%' }}>
                            Has the EMI been deposited in the UGRO-KVB escrow collections account ?
                        </span>
                        <div className="col-md-2" style={{ width: '15%' }}>
                            <div className='form-group' key={emiDeposited}>
                                <select
                                    value={emiDeposited}
                                    onChange={(e) => {
                                        setEmiDeposited(e.target.value);
                                        setLoanPaymentMode('');
                                        setEmiCollected('');
                                    }}
                                    className='form-control'
                                    placeholder=''
                                    style={{ fontSize: '11px' }}
                                    disabled={(apiStatus1 == 0 || apiStatus1 == 1)}
                                >
                                    <option value={null}>Please Select</option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                }
                {(emiDeposited == 0 && !noMore) &&
                    <div className='d-flex mb-3'>
                        <span style={{ fontSize: '13px', width: '70%' }}>
                            Has the EMI been collected from the customer and has it been transferred to the UGRO-KVB escrow collections account ?
                        </span>
                        <div className="col-md-2" style={{ width: '15%' }}>
                            <div className='form-group'>
                                <select
                                    value={emiCollected}
                                    onChange={(e) => {
                                        setEmiCollected(e.target.value);
                                        setLoanPaymentMode('');
                                        e.target.value == 0 && setShowErrorModal(true);
                                    }}
                                    className='form-control'
                                    placeholder=''
                                    style={{ fontSize: '11px' }}
                                    disabled={(apiStatus1 == 0 || apiStatus1 == 1)}
                                >
                                    <option value={null}>Please Select</option>
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                }
                {((emiDeposited == 1 || emiCollected == 1) && !noMore) &&
                    <div className='d-flex mb-4'>
                        <span style={{ fontSize: '13px', width: '70%' }}>
                            Please select the loan payment mode
                        </span>
                        <div className="col-md-2" style={{ width: '15%' }}>
                            <div className='form-group'>
                                {waitLoader ?
                                <div style={{'textAlign': 'center', 'fontWeight': 600}}>
                                    <div className='loader'></div>
                                    <div>Please wait</div>
                                </div>
                                :
                                <select
                                    value={loanPaymentMode}
                                    onChange={(e) => handleBankShareData(e)}
                                    className='form-control'
                                    placeholder=''
                                    style={{ fontSize: '11px' }}
                                    disabled={(apiStatus1 == 0 || apiStatus1 == 1)}
                                >
                                    <option value={null}>Please Select</option>
                                    <option value={1}>EMI</option>
                                    <option value={4}>Foreclosure</option>
                                </select>
                                }
                            </div>
                        </div>
                    </div>
                }
                {(apiStatus1 == 1 && !noMore) &&
                <>
                    <hr/>
                    <div className='d-flex'>
                        <div style={{'width': '100%'}}>
                            {(apiStatus2 == 0 || finalStatus == 0) &&
                                <button type="button" style={{'float': 'right', 'position': 'relative'}} class="btn btn-custom btn-custom-height" onClick={handleRetry}>Retry for UGRO Share</button>
                            }
                        </div>
                    </div>
                    <div className='d-flex mb-3' style={{'margin-top': '10px'}}>
                        <span style={{ fontSize: '13px', width: '70%' }}>
                            Please initiate UGRO {loanPaymentMode == 1? 'EMI': 'Foreclosure'} share
                        </span>
                        <div className="col-md-2" style={{ width: '15%' }}>
                            <div className='form-group'>
                                {(loader || loading) ?
                                    <button type="button" style={{'width': '90px'}} class="btn btn-custom btn-custom-height" disabled={true}><div className="loader"></div></button> :
                                    <button type="button" class="btn btn-custom btn-custom-height" disabled={[0,1].includes(apiStatus2) ? true : false} onClick={handleRetry}>Initiate{[0,1].includes(apiStatus2) ? 'd' : ''}</button>
                                }
                            </div>
                        </div>
                    </div>
                </>
                }
            </div>
            {/* Modal for updating Bank/Ugro Payment Data data */}
            <Modal
                state={showDataModal}
                closeModal={() => setShowDataModal(false)}
                style={{ width: "450px" }}
                removeBorderSpace={true}
                closeOnOverlayClick={false}
            >
                <div className="card border-0">
                    <div className="modal-header-container">
                        <div className="modal-title">{`Transaction details for ${part1? 'KVB': 'UGRO'} ${loanPaymentMode == 1? 'EMI': 'Foreclosure'} share`}</div> 
                        <div className="closeModalView" onClick={() => setShowDataModal(false)}>
                            <span className="closeModalIcon">x</span>
                        </div>
                    </div>
                    {((loanPaymentMode == 1 || loanPaymentMode == 4) && part1) &&
                        <div className='d-flex justify-content-center mt-3'>
                            <div className='row' style={{'width': '415px'}}>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <label>Escrow Account Number <tt>*</tt></label>
                                        <input
                                            value={escrowAccNumber}
                                            // onChange={(e) => setEscrowAccNumber(e.target.value)}
                                            type='text'
                                            maxLength='20'
                                            disabled={true}
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.EscrowAccount}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>{`${loanPaymentMode == 1 ? 'Repayment': 'Outstanding'} Amount`} <tt>*</tt></label>
                                        <input
                                            value={repaymentAmount}
                                            onChange={(e) => setRepaymentAmount(e.target.value.replace(/[^\d.]/g,''))}
                                            type='text'
                                            maxLength='15'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.Amount}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>Remarks <tt>*</tt></label>
                                        <input
                                            value={transactionRemarks}
                                            onChange={(e) => setTransactionRemarks(e.target.value)}
                                            type='text'
                                            maxLength='100'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.Narration}
                                        </tt>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className="justify-content-center mt-2">
                                        <button
                                            onClick={() => setShowConfirmationModal(true)}
                                            type='button'
                                            className='btn btn-custom btn-custom-height mb-2'
                                            style={{'margin-left': '160px'}}
                                        >
                                            {(loader || loading) ? <div className="loader"></div> : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {((loanPaymentMode == 1 || loanPaymentMode == 4) && part2) &&
                        <div className='d-flex justify-content-center mt-3'>
                            <div className='row' style={{'width': '415px'}}>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <label>UGRO Share {loanPaymentMode == 1? 'EMI': 'Foreclosure'} Amount <tt>*</tt></label>
                                        <input
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value.replace(/[^\d.]/g,''))}
                                            type='text'
                                            maxLength='15'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.Amount}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>Beneficiary Account Number <tt>*</tt></label>
                                        <input
                                            value={beneficiaryAccNumber}
                                            onChange={(e) => setBeneficiaryAccNumber(e.target.value)}
                                            type='text'
                                            maxLength='20'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.BenAcctNo}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>Beneficiery Account Type <tt>*</tt></label>
                                        <select
                                            value={beneficiaryAccType}
                                            onChange={(e) => setBeneficiaryAccType(e.target.value)}
                                            className='form-control'
                                            placeholder=''
                                            style={{ fontSize: '11px' }}
                                        >
                                            <option value={''}>Please Select</option>
                                            <option value={'SA'}>Savings</option>
                                            <option value={'CA'}>Current</option>
                                        </select>
                                        <tt>
                                            {errors && errors?.BenAcctType}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>Beneficiery IFSC <tt>*</tt></label>
                                        <input
                                            value={beneficiaryIFSC}
                                            onChange={(e) => setBeneficiaryIFSC(e.target.value)}
                                            type='text'
                                            maxLength='20'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.BenIFSC}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>Beneficiery Name <tt>*</tt></label>
                                        <input
                                            value={beneficiaryName}
                                            onChange={(e) => setBeneficiaryName(e.target.value)}
                                            type='text'
                                            maxLength='100'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.BenName}
                                        </tt>
                                    </div>
                                    <div className='form-group'>
                                        <label>Remarks <tt>*</tt></label>
                                        <input
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                            type='text'
                                            maxLength='100'
                                            className='form-control'
                                        />
                                        <tt>
                                            {errors && errors?.Remarks}
                                        </tt>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className="justify-content-center mt-2">
                                        <button
                                            onClick={() => setShowConfirmationModal(true)}
                                            type='button'
                                            className='btn btn-custom btn-custom-height mb-2'
                                            style={{'margin-left': '160px'}}
                                        >
                                            {(loader || loading) ? <div className="loader"></div> : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Modal>
            {/* Modal for showing message */}
            <Modal
                state={showErrorModal}
                closeModal={() => setShowErrorModal(false)}
                style={{ width: "555px" }}
                removeBorderSpace={true}
            >
                <div className="card border-0">
                    <div className="modal-header-container">
                        <div className="modal-title">{''}</div>
                        <div className="closeModalView" onClick={() => setShowErrorModal(false)}>
                            <span className="closeModalIcon">x</span>
                        </div>
                    </div>
                    <div className="p-4">
                        <p>Please deposit the EMI amount in the UGRO-KVB collections escrow account and then initiate.</p>
                    </div>
                </div>
            </Modal>
            {/* Modal for confirmation message */}
            <Modal
            state={showConfirmationModal}
            closeModal={() => setShowConfirmationModal(false)}
            style={{ width: "450px" }}
            removeBorderSpace={true}
            closeOnOverlayClick={false}
            >
			<div className='p-4' style={{'textAlign': 'center'}}>
				<p className='font-weight-bold'>
                    Are you sure you want to submit?
				</p>
				<div className='d-flex align-items-center mt-4' style={{'margin-left': '150px'}}>
					<Button
						clickHandler={handleConfirmationModal}
						classNames='btn-custom'
					>
						Yes
					</Button>
					<Button
						clickHandler={() => setShowConfirmationModal(false)}
						classNames='btn-outline-custom ml-2'
					>
						No
					</Button>
				</div>
			</div>
		</Modal>
        </div>
    )
}

export default CollectionDetails
